<template>
    <div class="i-modal-fade" v-if="opened" @click="hideIt">
        <div class="i-modal-window">
            <div class="i-modal-head">
            	<div class="fal fa-times exit-btn" @click="close"></div>
            </div>
            <div class="i-modal-body" v-html="content">
            </div>
        </div>
    </div>
</template>
<script>
function hasClass(element, className) {
    return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
}
export default {

    name: 'i-modal',
    methods:{
    	close(){
    		this.$emit('onClose');
    	},
    	hideIt(e){
    		if(hasClass(e.target,'i-modal-fade')){
    			this.close();
    		}
    		//if(e.target.classList)
    	}

    },
    props: {
    	width: {type:[Number, String], default: 400},
    	content: {type:String, default:''},
    	opened: {type:Boolean, default:false}
    	
    },
    watch:{
    	opened(ne,old){
    		window.document.body.style.overflowY = ne?"hidden":"auto"
    	}
    },
    data() {
        return {
        	hide:false
        	//1,6180339887

        }
    }
}
</script>
<style lang="css" scoped>
.i-modal-fade {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.75);
    position: fixed;
    z-index: 660;
    overflow-y: auto;
}

.i-modal-window {
    margin: 20px auto;
    background: white;
    width:61.8033988%;
    border-radius: 4px;
    padding:20px;
    max-width: 800px;
}
.i-modal-head{
	text-align: right;
}
.exit-btn{
	display: inline-block;
	position: absolute;
	margin-right: -4px;
	margin-top: -12px;
	cursor: pointer;
	color:lightgrey;
}
.exit-btn:hover{
	color:grey;
}
</style>